import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useState, useContext, useMemo } from 'react';
// import { Transition } from '@headlessui/react'
// import { CheckCircleIcon } from '@heroicons/react/24/outline'
// import { XMarkIcon } from '@heroicons/react/20/solid'
//import { NotificationContext } from 'contexts/ContextValidationNotify/ContextValidationNotify';
import { UIContext } from "contexts/UIContext";
import { NotifyItem } from 'components/UI/Notify/NotifyItem';
/* 사용방법
import { fieldValidator } from 'utils/fieldValidation';
import { ValidationNotifyContext } from 'contexts/ContextValidationNotify/ContextValidationNotify';

let msgNumber = Number(new Date);
const { data, setData } = useContext(ValidationNotifyContext);

let result: any[] = fieldValidator([
    { key: 'id', value: id, condition: {NullNotAllowed: true, Length: 20} },
    { key: 'password', value: password, condition: {NullNotAllowed: false, Length: 20} },
]);

result.forEach( (item) => {
    //조건 검사
    setData ({key: msgNumber++, msg: });
})
*/
let list2 = [];
export const Notify = ({ lng }) => {
    console.log('[Notification] Init');
    const { notifyStore } = useContext(UIContext);
    let listKey = Number(new Date());
    const [list, setList] = useState([]);
    let timer;
    let test = useMemo(() => {
        console.log('[Notification] useMemo');
        //초기 데이터는 노티하지 않음
        if (notifyStore.contents === "init")
            return 0;
        console.log('KKKKKKKKKKk');
        let thisKey = listKey++;
        let item = {
            key: thisKey,
            type: notifyStore.type,
            contents: notifyStore.contents
        };
        console.log(item);
        list2.push(item);
        setList(list2);
        timer = setTimeout(() => {
            const removeKey = thisKey;
            list2 = list2.filter(item => item.key !== removeKey);
            clearInterval(timer);
        }, 3000);
    }, [notifyStore]);
    if (notifyStore.contents === "init")
        return (_jsx(_Fragment, {}));
    return (_jsx(_Fragment, { children: _jsx("div", { "aria-live": "assertive", className: "pointer-events-none fixed inset-0 flex items-end px-4 py-6 sm:items-start sm:p-6 z-1000", children: _jsx("div", { className: "flex w-full flex-col items-center space-y-4 sm:items-end", children: list.map((item) => (_jsx(NotifyItem, { lng: lng, type: item.type, contents: item.contents }, item.key))) }) }) }));
};
